module.exports = __webpack_public_path__ + "components/page-footer/static/weather-forecast__logo--white-dc5df6d65abf869596a8f414e90fad4d.png";